"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _colors = require("../../colors");
var Theme = {
  green: {
    foregroundColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.GREEN_500
  },
  poppy: {
    foregroundColor: _colors.FullPalette.POPPY_700,
    backgroundColor: _colors.FullPalette.POPPY_500
  },
  pale: {
    foregroundColor: _colors.FullPalette.GREEN_700,
    backgroundColor: _colors.FullPalette.GREEN_E25
  }
};
var _default = exports["default"] = Theme;